import { Component, OnInit, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { empModulo } from '../../diccionarios/empModulo';
import { EncuestaCampeones } from '../models/encuestaCampeons';
import { SeleccionCargasService } from '../seleccion-cargas.service';

@Component({
  selector: 'app-csv-campeon-compromiso',
  templateUrl: './csv-campeon-compromiso.component.html',
  styleUrls: ['./csv-campeon-compromiso.component.css']
})

export class CsvCampeonCompromisoComponent implements OnInit {

  public titulo  = "Encuesta/Entrevista: de Campeones";
  public mostrarFormulario = false;
  public modulo: any = empModulo;
  public loading: boolean = false;
  public listaVacia: boolean = true;
 
  public year = (new Date()).getFullYear();
  cmbAnio = [
    { clave: this.year-1, valor: (this.year -1).toString()},
    { clave: this.year,   valor: this.year.toString() },
    { clave: this.year+1, valor: (this.year + 1).toString() },
    { clave: this.year+2, valor: (this.year + 2).toString() },
  ];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];
  errorData: boolean = true;
  
  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private cargasServices: SeleccionCargasService,
  ) { }

  ngOnInit(): void {

    this.formulario = this.fb.group({
      anio: ['', [Validators.required]],
      multipart: ['', [Validators.required]]
    });

    this.formulario.get('anio').setValue(this.year);
    this.cargarGrid();

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  cargarGrid(){
    this.columnDefs = [
      { headerName: 'ESTADO', sortable: true, filter: true, width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      { field: 'direccionLF', width: 120, sortable: true, resizable: true},
      { field: 'anio', width: 120,sortable: true},
      { field: 'valor', width: 120, sortable: true },
      { headerName: 'ERROR', field: 'error.errorCampo', filter: true, width: 600, sortable: true,
        cellStyle: this.changeRowColor.bind(this),
      },
    ];
    this.rowSelection = 'multiple';
  }

  downloadCsvFormato() {
    let cabecera: any[] = [['DireccionLf', 'Valor']];
    let name: string = "formato-plantilla.csv";
    
    const data: any[] = [];
    this._util.exportCSV(cabecera, data, name);
  }

  enviarFormulario() {
    const anio = this.formulario.get('anio').value;
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    let params = '?anio='+anio+'&usuario='+userData.login2;
    this.loading = true;

    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: 'carga campeones de compromiso',
        action: 'Enviar',
        funcion: this.cargasServices.cargaCsvCampeones(this.setFormData(this.formulario.value), params),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });

    this.loading = false;
  }

  guardar() {
    this.loading = true;
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar?',
        text: '',
        action: 'Guardar',
        funcion: this.cargasServices.saveCargaCsvCampeones(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this._util.mensajeOKVisto(res, true, 10000);
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
    this.loading = false;
  }

  downloadDataCsv(){
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (e.correct) {
        this.errorData = false;
      }
    });
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    this.formulario.get('multipart').setValue("");
    
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {'background-color': 'lightgreen', 'color': 'black', 'font-weight': 'bold'};
      }
      else {
        return {'background-color': '#FFC0CB', 'color': 'black', 'font-weight': 'bold'};
      }
    }
    return true;
  }


}
